/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  RiskIDRequestBody,
  RiskIDRequestBody$Outbound,
  RiskIDRequestBody$outboundSchema,
} from "../components/riskidrequestbody.js";

export type RefreshGlobalRemoteSessionIssuerMetadataSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type RefreshGlobalRemoteSessionIssuerMetadataRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  riskIDRequestBody: RiskIDRequestBody;
};

/** @internal */
export type RefreshGlobalRemoteSessionIssuerMetadataSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const RefreshGlobalRemoteSessionIssuerMetadataSecurity$outboundSchema:
  z.ZodMiniType<
    RefreshGlobalRemoteSessionIssuerMetadataSecurity$Outbound,
    RefreshGlobalRemoteSessionIssuerMetadataSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function refreshGlobalRemoteSessionIssuerMetadataSecurityToJSON(
  refreshGlobalRemoteSessionIssuerMetadataSecurity:
    RefreshGlobalRemoteSessionIssuerMetadataSecurity,
): string {
  return JSON.stringify(
    RefreshGlobalRemoteSessionIssuerMetadataSecurity$outboundSchema.parse(
      refreshGlobalRemoteSessionIssuerMetadataSecurity,
    ),
  );
}

/** @internal */
export type RefreshGlobalRemoteSessionIssuerMetadataRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  RiskIDRequestBody: RiskIDRequestBody$Outbound;
};

/** @internal */
export const RefreshGlobalRemoteSessionIssuerMetadataRequest$outboundSchema:
  z.ZodMiniType<
    RefreshGlobalRemoteSessionIssuerMetadataRequest$Outbound,
    RefreshGlobalRemoteSessionIssuerMetadataRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      riskIDRequestBody: RiskIDRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        riskIDRequestBody: "RiskIDRequestBody",
      });
    }),
  );

export function refreshGlobalRemoteSessionIssuerMetadataRequestToJSON(
  refreshGlobalRemoteSessionIssuerMetadataRequest:
    RefreshGlobalRemoteSessionIssuerMetadataRequest,
): string {
  return JSON.stringify(
    RefreshGlobalRemoteSessionIssuerMetadataRequest$outboundSchema.parse(
      refreshGlobalRemoteSessionIssuerMetadataRequest,
    ),
  );
}
